import React from 'react';
import { useDrop } from 'react-dnd';

import CatalogCard from './CatalogCard';

const TargetBox = (props) => {
  const {
    catalogList,
    moveCard,
    pushCard,
    onDrop,
    handleCollapse,
    collapsedItems,
    befores,
    setBefores,
    handleDeleteCatalogItem,
    handleEditCatalogueTitle,
  } = props;
  const [{ isActive }, drop] = useDrop({
    accept: 'card',
    drop: (item, monitor) => {
      onDrop(item, monitor);
      setBefores({});
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver(),
    }),
  });

  return (
    <div ref={drop} style={{ height: '100%' }}>
      <ol className="dd-list" id="catalogList">
        {catalogList.length
          ? catalogList.map((collection, i) => (
              <CatalogCard
                key={collection.id}
                index={i}
                originalItem={collection}
                moveCard={moveCard}
                pushCard={pushCard}
                handleCollapse={handleCollapse}
                collapsedItems={collapsedItems}
                befores={befores}
                setBefores={setBefores}
                handleDeleteCatalogItem={handleDeleteCatalogItem}
                handleEditCatalogueTitle={handleEditCatalogueTitle}
              />
            ))
          : null}
      </ol>
    </div>
  );
};
export default TargetBox;
